import { ADMINS, MANAGERS } from '../../helpers/constants';

export const selectSignIn = state => {
  return state.auth.isSignedIn;
};

export const selectUserType = state => {
  return state.auth.user?.typeAccount;
};
export const selectUser = state => {
  return state.auth.user;
};
export const selectUserBalance = state => {
  return state.auth.balance;
};
export const selectToken = state => {
  return state.auth.token;
};

export const selectIsAdmin = state => {
  return ADMINS.includes(state.auth.user?._id);
};

export const selectIsManager = state => {
  return MANAGERS.includes(state.auth.user?._id);
};

export const selectIsAgency = state => {
  return state.auth.user?.typeAccount === 'agencyUser';
};
